import React from 'react';
import { Label } from 'semantic-ui-react';
import { filterWithMinimumLength, removeDuplicates } from '@/utils/resultsHelper';
import LinksLabels from '@/components/LinksLabels';
import FormStringsDescriptionWrapper from './FormStringsDescriptionWrapper';
import { safeFormArray } from '../state/state';

const FormStringLinksDescription = ({ canEdit, showEdit, text }) => {
  const items = removeDuplicates(filterWithMinimumLength(safeFormArray(text) || []), true);

  return (
    <>
      {items.length > 0 && (
        <Label.Group className="aridhia-form-strings-description aridhia-h4 aridhia-tag">
          <LinksLabels items={items} />
        </Label.Group>
      )}
      {items.length === 0 && (<FormStringsDescriptionWrapper canEdit={canEdit} showEdit={showEdit} />)}
    </>
  );
};

export default FormStringLinksDescription;
